import React from 'react';



import Navbar from '../inc/Navbar';

function Privacy (props) {
    return (

        <>
        <Navbar/>
        <br/>
      <br/>
      <br/>
<div className="album py-5">
        
        <div className="container">

        <div className="row">

        <div className="col-md-30">
                    <div className="card mb-4 box-shadow">
                    <div className="card-body">
                    <h5 className="card-text"  style= {{textAlign: "center"}}><b>PRIVACY POLICY</b></h5>
                    <br/>
                            <h6 className="card-text"> <b>Astha Digital Services</b> 
                             </h6>
                            <p className="card-text">Please read these terms of use carefully. By continuing to access and use this application you confirm that you accept our terms and conditions described herein. If you do not agree the terms of use, do not use this application. </p>
                            <p className="card-text"><b>Privacy Policy</b></p>
                            <p className="card-text">  This Privacy Policy ("Policy") is made, and hosted in accordance with the following Information Technology Laws,
</p>
<p className="card-text">i.  Information Technology Act, 2000</p>
<p className="card-text">ii. Rule 3(1)(a) of the Information Technology (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021;</p>
<p className="card-text">iii. Rule 4 of the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Information) Rules, 2011</p>
<p className="card-text">This Policy document is an 'electronic record' within the meaning of section 2(t) of the Information Technology Act, 2000 and the rules made thereunder. This Policy being an electronic record requires no signature <br/><br/>This Policy should be read in conjunction with the "Terms and Conditions of Use" of the Digital Platform which are deemed to have been incorporated herein by way of reference. </p>
<p className="card-text"><b>Usage</b></p>
<p className="card-text">This Policy conveys the mode, method and manner in which Astha Digital Services collects, stores and disseminates the Personal Information ("Information") from the Users (hereinafter referred to as "User" "Users" or "you"). For the purpose of this Policy User(s) shall mean such individuals who are competent to contract under the Indian Contract Act, 1872 and wish to subscribe to the Services (offered by Astha Digital Services by itself or through third party service providers) on this Digital Platform by visiting this Digital Platform, Astha Digital Services therefore requests the Users on this Digital Platform, to carefully and comprehensively read and understand the Policy before they consent to the terms herein and start using or accessing this Digital Platform or subscribing to any of the Services offered through this Digital Platform. In the event of any disagreement or Users do not accept to the terms of this Policy or the Terms of Use of this Digital Platform herein they are advised to forthwith disengage and leave this Digital Platform.</p>
<p className="card-text"><b>GRIEVANCE OFFICER</b></p>      
<p className="card-text">In case of any complaints or grievances, the User may contact the Grievance Officer as under:</p>                        
<p className="card-text ">Head Customer Care :  <a href="tel: +91 7584813719"  className="btn-light mb-3">    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-forward" viewBox="0 0 16 16">
  <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z"/>
</svg> +91 75848 13719</a> </p>  
Email ID: <a href="mailto: servicesasthadigital@gmail.com">servicesasthadigital@gmail.com
</a>    

</div></div>
</div>
</div>
</div>




</div>
                            
        </>

);
}

export default Privacy;